import React, {useState} from 'react';
import { linkTo } from '../utils/uiUtils';
import { LISTING_TYPE } from '../platformUtils';
import useMostPopularProperties from '../hooks/useMostPopularProperties';
import useTrendingProperties from '../hooks/useTrendingProperties';
import useRecommendedProperties from '../hooks/useRecommendedProperties';

import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import RoundedButton from '../components/RoundedButton/RoundedButton';

function ErrorPage(props) {
    const errStatus = props.status || '???';
    const errMessage = props.message || 'Hm, that\'s not good. Hopefully it works itself out. Head back home?';

    return <>
        <Navbar />
        <div className="flex flex-col justify-center items-center">
            <div className="px-4 py-20">
                <h1 className="font-foslin text-8xl font-bold mb-5">{errStatus}</h1>
                <p className="mb-12">
                    { errMessage }
                </p>
                <RoundedButton onClick={() => linkTo('/')} >Back to Homepage</RoundedButton>
            </div>
        </div>
        <Footer />
    </>;
}

export default ErrorPage;